const CONSTANTS = {
    FOOTER:{
        LINKS: [
            { label: "payByLink.footer.link.dataProtectionPolicy.label", url: "payByLink.footer.link.dataProtectionPolicy.url" },
            { label: "payByLink.footer.link.termsAndConditions.label", url: "payByLink.footer.link.termsAndConditions.url" }
        ],
        LOGO_LABLE: "payByLink.footer.logo.label"
    },

    CHECKOUT_DETAILS: {
        SECTION_HEADING: "payByLink.checkoutdetails.sectionHeading",
        QUANTITY: "payByLink.checkoutdetails.quantity",
        TAX_AMOUNT: "payByLink.checkoutdetails.taxAmount",
        SHIPPING_COST: "payByLink.checkoutdetails.shippingCost",
        DISCOUNT:"payByLink.checkoutdetails.discount",
        HANDLING_FEE:"payByLink.checkoutdetails.handlingfee",
        TOTAL_AMOUNT: "payByLink.checkoutdetails.totalAmount"
    },

    PAYMENT_METHODS: {
        SECURED_INVOICE: "payByLink.paymentMethods.securedInvoice",
        SECURED_INSTALLMENT: "payByLink.paymentMethods.securedInstallment",
        SECURED_DIRECT_DEBIT: "payByLink.paymentMethods.securedDirectDebit",
        SECTION_HEADING: "payByLink.paymentMethods.sectionHeading",
        SUB_SECTION_HEADING: "payByLink.paymentMethods.subsectionHeading",
        PAGE_HEADING: "payByLink.paymentMethods.pageHeading",
        SUB_PAGE_HEADING: "payByLink.paymentMethods.subPageHeading"
    },

    INSTALLMENT_OPTIONS: {
        HEADING: "payByLink.installmentOptions.heading",
        SUB_HEADING: "payByLink.installmentOptions.subHeading",
        RATES_PER: "payByLink.installmentOptions.ratesPer",
        DETAILS: {
            RATE_DETAILS: "payByLink.installmentOptions.details.rateDetails",
            NUMBER_OF_PAYMENTS: "payByLink.installmentOptions.details.numberOfPayments",
            MONTHLY_AMOUNT_VALUE: "payByLink.installmentOptions.details.monthlyAmountValue",
            TOTAL_AMOUNT: "payByLink.installmentOptions.details.totalAmount",
            DEBIT_INTEREST_PA_FIXED: "payByLink.installmentOptions.details.debitInterestPAFixed",
            EFFECTIVE_INTEREST_RATE: "payByLink.installmentOptions.details.effectiveInterestRate",
            DOWNLOAD_INSTALLMENT_INFORMATION: "payByLink.installmentOptions.details.downloadInstallmentInformation"
        }
    },

    BUTTON: {
        BACK_TO_THE_SHOP: "payByLink.successPage.button.backToTheShop",
        RETRY_PAYMENT_METHOD: "payByLink.statusPage.retryPaymentMethod"
    },

    LOADING: {  
        LOADING_TEXT: "payByLink.loading.loadingText",
        MESSAGE: "payByLink.loading.message"
    },

    FORM_EDIT: {
        EDIT_LINK_TEXT: "payByLink.formEdit.editLinkText",
        SAVE_BUTTON_TEXT: "payByLink.formEdit.saveButtonText"
    },

    PAYMENT_FORM: {
        PAGE_HEADING: "payByLink.paymentForm.pageHeading",
        PAGE_SUB_HEADING: "payByLink.paymentForm.pageSubHeading",
        SECTION_HEADINGS: {
            CUSTOMER: "payByLink.paymentForm.sectionHeading.customer",
            CONTACT_INFORMATION: "payByLink.paymentForm.sectionHeading.contactInformation",
            CONTACT_SUB_INFORMATION: "payByLink.paymentForm.sectionHeading.contactSubInformation",
            BILLING_ADDRESS: "payByLink.paymentForm.sectionHeading.billingAddress",
            BILLING_SUB_HEADING: "payByLink.paymentForm.sectionHeading.billingSubHeading",
            SPECIAL_PARAMETERS: "payByLink.paymentForm.sectionHeading.specialParameters"
        },
        LABEL: {
            BUSINESS_RELATION: "payByLink.paymentForm.label.businessRelation",
            COMPANY_NAME: "payByLink.paymentForm.label.companyName",
            FIRST_NAME: "payByLink.paymentForm.label.firstName",
            LAST_NAME: "payByLink.paymentForm.label.lastName",
            DATE_OF_BIRTH: "payByLink.paymentForm.label.dateOfBirth",
            EMAIL_ADDRESS: "payByLink.paymentForm.label.emailAddress",
            PHONE_NUMBER: "payByLink.paymentForm.label.phoneNumber",
            STREET_NAME_AND_HOUSE_NUMBER: "payByLink.paymentForm.label.streetNameAndHouseNnumber",
            ZIP_CODE: "payByLink.paymentForm.label.zipCode",
            CITY: "payByLink.paymentForm.label.city",
            COUNTRY: "payByLink.paymentForm.label.country",
            IBAN: "payByLink.paymentForm.label.IBAN",
            BANK_ACCOUNT_HOLDER: "payByLink.paymentForm.label.bankAccountHolder",
            CHECKBOX_SEC_TITLE: "payByLink.paymentForm.label.checkBoxSecTitle",
            CHECKBOX_SEC_INSTALLMENT_TITLE: "payByLink.paymentForm.label.checkBoxInstallmentSecTitle",
            CHECKBOX_TEXT: "payByLink.paymentForm.label.checkBoxText",
            CHECKBOX_DESCRIPTION: "payByLink.paymentForm.label.checkboxDescription",
            CHECKBOX_DESCRIPTION_PAYPAL: "payByLink.paymentForm.label.checkboxDescriptionPaypal",
            CHECKBOX_DESCRIPTION_WERO: "payByLink.paymentForm.label.checkboxDescriptionWero",
            CHECKBOX_TEXT_INSTALLMENT: "payByLink.paymentForm.label.Installment.checkBoxText",
            CHECKBOX_INSTALLMENT_DESCRIPTION: "payByLink.paymentForm.label.installment.checkboxDescription",
            DROPDOWN_OPTIONS: {
                BUSINESS_RELATION: {
                    B2C: "payByLink.paymentForm.dropdownOption.label.B2C",
                    B2B: "payByLink.paymentForm.dropdownOption.label.B2B"
                },
                COUNTRY: {
                    AUSTRIA: "payByLink.paymentForm.dropdownOption.label.austria",
                    GERMANY: "payByLink.paymentForm.dropdownOption.label.germany",
                    FRANCE: "payByLink.paymentForm.dropdownOption.label.france",
                    BELGIUM: "payByLink.paymentForm.dropdownOption.label.belgium",
                }
            }
        },
        BUTTON: {
            SUBMIT_PAYMENT: "payByLink.paymentForm.button.submitPayment",
            SHOW_INSTALLMENT_OPTIONS: "payByLink.paymentForm.button.showInstallmentOptions",
            CHOOSE_OTHER_PAYMENT_METHOD: "payByLink.paymentForm.button.chooseOtherPaymentMethod",
            GO_TO_OVERVIEW:"payByLink.paymentForm.button.goToOverview"
        },
        ERROR_MSG: {
            INVALID_DOB: "payByLink.paymentForm.validations.dateOfBirth" 
        },
        PLACEHOLDER: {
            COMPANY_NAME: "payByLink.paymentForm.placeholder.companyName",
            FIRST_NAME: "payByLink.paymentForm.placeholder.firstName",
            LAST_NAME: "payByLink.paymentForm.placeholder.lastName",
            DATE_OF_BIRTH: "payByLink.paymentForm.placeholder.dateOfBirth",
            EMAIL_ADDRESS: "payByLink.paymentForm.placeholder.emailAddress",
            PHONE_NUMBER: "payByLink.paymentForm.placeholder.phoneNumber",
            STREET_NAME_AND_HOUSE_NUMBER: "payByLink.paymentForm.placeholder.streetNameAndHouseNumber",
            ZIP_CODE: "payByLink.paymentForm.placeholder.zipCode",
            CITY: "payByLink.paymentForm.placeholder.city",
            IBAN: "payByLink.paymentForm.placeholder.IBAN",
            BANK_ACCOUNTHOLDER: "payByLink.paymentForm.placeholder.bankAccountHolder",
        }
    },

    PAYMENT_CHECKBOX_TEXT: "Approval of the terms of payment",
    PAYMENT_CHECKBOX_DESCRIPTION: "By placing this order, I agree to the&nbsp;<a href='https://legal.paylater.payone.com/en/terms-of-payment.html' target='_blank' rel='noopener noreferrer' data-testid='pm-link-term-of-payment'>supplementary payment terms</a>&nbspand the performance of a risk assessment for the selected payment method. I am aware of the&nbsp; <a href='https://legal.paylater.payone.com/en/data-protection-payments.html' target='_blank' rel='noopener noreferrer' data-testid='pm-link-data-protection-payment'>supplementary data protection notice</a>.",
    CHECKBOX_DESCRIPTION_PAYPAL:"After clicking on Complete Payment button you will be redirected to Paypal.",
    CHECKBOX_DESCRIPTION_WERO:"After clicking on Complete Payment button you will be redirected to WERO.",
    PAYMENT_CHECKBOX_TEXT_INSTALLMENT: "Approval of the data protection notice",
    PAYMENT_CHECKBOX_INSTALLMENT_DESCRIPTION: "By requesting installment options, I agree with <a href='https://legal.paylater.payone.com/en/data-protection-payments.html' target='_blank' rel='noopener noreferrer' data-testid='pm-link-data-protection-payment'>supplementary data protection information.</a>",

    SUCCESS_PAGE: {
        DISPLAY_MESSAGE: {
            PAYMENT_SUCCESSFUL: "payByLink.successPageMessages.displayMessage.paymentSuccessful",
            THANK_YOU_MESSAGE: "payByLink.successPageMessages.displayMessage.thankYouMessage",
            TRANSACTION_COMPLETED: "payByLink.successPageMessages.displayMessage.transactionCompleted",
            EMAIL_SENT: "payByLink.successPageMessages.displayMessage.emailSent",
            REDIRECT_MSG_PART1: "payByLink.successPageMessages.displayMessage.redirectMessagePart1",
            REDIRECT_MSG_PART2: "payByLink.successPageMessages.displayMessage.redirectMessagePart2"
        }
    },
    PAYMENT_STATUS :{
        DISPLAY_MESSAGE: {
            PAYMENT_PROCESSING:"payByLink.paymentStatusMessages.displayMessage.paymentProcessing",
            PLEASE_WAIT:"payByLink.paymentStatusMessages.displayMessage.pleaseWait",
            REDIRECT_MSG_PART1:"payByLink.paymentStatusMessages.displayMessage.redirectMessagePart1",
        }
    },
    
    Error_PAGE: {
        DISPLAY_MESSAGE: {
            SORRY_MESSAGE: "payByLink.errorPageMessages.displayMessage.sorryMessage",
            ERROR_OCCURRED: "payByLink.errorPageMessages.displayMessage.errorOccurred",
            LINK_EXPIRED: "payByLink.errorPageMessages.displayMessage.linkExpired",
            CONTACT_SELLER: "payByLink.errorPageMessages.displayMessage.contactSeller",
        }
    },

    NOT_FOUND_PAGE: {
        STATUS_CODE: "payByLink.notFoundPage.statusCode",
        STATUS_MESSAGE: [
            "payByLink.notFoundPage.stausMessage.notFound",
            "payByLink.notFoundPage.stausMessage.cannotFind"
        ]
    },

    VALIDATION_ERRORS: {
        CUSTOMER: {
            COMPANY: {
                EMPTY: "payByLink.validationError.customer.company.empty",
            },
            FIRST_NAME : {
                EMPTY: "payByLink.validationError.customer.firstName.empty",
            },
            LAST_NAME: {
                EMPTY: "payByLink.validationError.customer.lastName.empty",
            },
            DOB: {
                EMPTY: "payByLink.validationError.customer.dob.empty",
                INVALID: "payByLink.validationError.customer.dob.invalid",
            }
        },
        CONTACT: {
            EMAIL: {
                EMPTY: "payByLink.validationError.contact.email.empty",
                INVALID: "payByLink.validationError.contact.email.invalid",
            },
            PHONE: {
                EMPTY: "payByLink.validationError.contact.phone.empty",
                INVALID: "payByLink.validationError.contact.phone.invalid",
            }
        },
        BILLING: {
            ADDRESS: {
                EMPTY: "payByLink.validationError.billing.address.empty",
                TOO_LONG: "payByLink.validationError.billing.address.tooLong",
            },
            ZIP_CODE: {
                EMPTY: "payByLink.validationError.billing.zipcode.empty",
                INVALID: "payByLink.validationError.billing.zipcode.invalid"
            },
            CITY: {
                EMPTY: "payByLink.validationError.billing.city.empty",
                TOO_SHORT: "payByLink.validationError.billing.city.tooShort",
                TOO_LONG: "payByLink.validationError.billing.city.tooLong",
            },
        },
        PAYMENT: {
            IBAN: {
                EMPTY: "payByLink.validationError.payment.iban.empty",
                INVALID: "payByLink.validationError.payment.iban.invalid"
            },
            ACCOUNT_HOLDER_NAME: {
                EMPTY: "payByLink.validationError.payment.accountHolderName.empty",
                TOO_LONG: "payByLink.validationError.payment.accountHolderName.tooLong"
            }
        },
        TERMS_AND_CONDITIONS: {
            NOT_AGREED: "payByLink.validationError.termsAndConditions.notAgreed"
        },
        DATA_PROTECTION: {
            NOT_AGREED: "payByLink.validationError.dataProtection.notAgreed"
        },
        PAYMENT_METHOD: "payByLink.validationError.paymentMethod"
    },
    NO_DATA_AVAILABLE: "payByLink.stausMessage.noDataAvailable",
    PAYLA_PARTNER_ID: 'e7yeryF2of8X',

    COOKIE: {
        MESSAGE: "payByLink.cookie.message",
        AGREE: "payByLink.cookie.agree",
    },

    PROD_URL: 'https://paylink.commerce.payone.com',

    PAYMENT_PROCESSING: {
        PRIMARY_MESSAGE: "payByLink.paymentProcess.processingMessagePrimary",
        SECONDARY_MESSAGE: "payByLink.paymentProcess.processingMessageSecondary",
    },

    PAYMENT_PROCESSING_INSTALLMENT :{
        PRIMARY_MESSAGE:"payByLink.paymentProcess.processingMessagePrimaryForInstallment",
        SECONDARY_MESSAGE:"payByLink.paymentProcess.processingMessageSecondaryForInstallment"
    },

    CREDITCARD_PAGE: {
        HEADING: "payByLink.creditcard.sectionHeading",
        SUB_HEADING: "payByLink.creditcard.sectionSubHeading",
    },

    ERROR_WIDGET: {
        PRIMARY: "payByLink.errorWidget.message.primary",
        SECONDARY: "payByLink.errorWidget.message.secondary",
        PAYPAL_SECONDARY:"payByLink.errorWidget.message.paypalSecondary"
    }
}

export default CONSTANTS;